(function (root) {
  'use strict';
  function calculate(rules, balance, purchase, tierIndex, rewardIndex) {
    if (String(balance).trim() === '' || String(purchase).trim() === '') return null;
    var points = Number(balance), amount = Number(purchase);
    var tier = rules.tiers[tierIndex], reward = rules.rewards[rewardIndex];
    if (!Number.isInteger(points) || points < 0 || points > 100000 || !Number.isFinite(amount) || amount < 0 || amount > 10000 || !tier || !reward) return null;
    var cents = Math.round(amount * 100);
    if (Math.abs(amount * 100 - cents) > 0.000001) return null;
    var earned = Math.floor(cents * tier.multiplier * rules.points_per_eur / 100 + 1e-9);
    var total = points + earned;
    return { earned: earned, total: total, missing: Math.max(0, reward.points - total), progress: Math.min(100, total / reward.points * 100), reward: reward };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { calculate: calculate };
  if (!root.document) return;
  function init(scope) {
    scope.querySelectorAll('[data-insiders]').forEach(function (section) {
      if (section.dataset.insReady) return;
      var rules;
      try { rules = JSON.parse(section.querySelector('[data-ins-rules]').textContent); }
      catch (_) { return; }
      var balance = section.querySelector('[data-ins-balance]');
      var purchase = section.querySelector('[data-ins-purchase]');
      var tier = section.querySelector('[data-ins-tier]');
      var result = section.querySelector('[data-ins-result]');
      var error = section.querySelector('[data-ins-error]');
      var rewards = section.querySelectorAll('[data-ins-reward]');
      var rewardIndex = 0, timer;
      var number = new Intl.NumberFormat(section.dataset.locale || 'en');
      var currency = new Intl.NumberFormat(section.dataset.locale || 'en', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      function update() {
        var value = calculate(rules, balance.value, purchase.value, Number(tier.value), rewardIndex);
        var valid = value && balance.validity.valid && purchase.validity.valid;
        balance.setAttribute('aria-invalid', String(!balance.validity.valid));
        purchase.setAttribute('aria-invalid', String(!purchase.validity.valid));
        error.hidden = !!valid;
        result.hidden = !valid;
        if (!valid) return;
        result.querySelector('[data-ins-total]').textContent = number.format(value.total);
        result.querySelector('[data-ins-earned]').textContent = '+' + number.format(value.earned);
        result.querySelector('[data-ins-progress]').style.width = value.progress + '%';
        result.querySelector('[data-ins-value]').textContent = currency.format(value.reward.eur);
        result.querySelector('[data-ins-minimum]').textContent = result.dataset.minimum.replace('__AMOUNT__', number.format(value.reward.minimum));
        result.querySelector('[data-ins-message]').textContent = value.missing ? result.dataset.missing.replace('__POINTS__', number.format(value.missing)) : result.dataset.ready;
      }
      rewards.forEach(function (button) {
        button.addEventListener('click', function () {
          rewardIndex = Number(button.dataset.insReward);
          rewards.forEach(function (other) { other.setAttribute('aria-pressed', String(other === button)); });
          clearTimeout(timer); update();
        });
      });
      [balance, purchase].forEach(function (input) { input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(update, 180); }); });
      tier.addEventListener('change', update);
      section.dataset.insReady = 'true';
      update();
    });
  }
  init(root.document);
  root.document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})(typeof window === 'undefined' ? globalThis : window);
